import React from 'react';
import { FormControl, FormErrorMessage, FormLabel, Select, Text, useColorModeValue } from '@chakra-ui/react';

const Dropdown = ({
    label,
    value,
    onChange,
    options = [],
    required = false,
    textColor = 'black',
    isInvalid,
    errorMessage = '',
}) => {
    const brandStars = useColorModeValue('red.500', 'red.400');

    return (
        <FormControl isInvalid={isInvalid} mb="24px">
            <FormLabel display="flex" fontSize="l" fontWeight="900" color={textColor} mb="10px">
                {label} {required && <Text color={brandStars}>*</Text>}
            </FormLabel>
            <Select
                fontSize="sm"
                id="currency-select"
                variant="main"
                h="44px"
                maxH="44px"
                value={value}
                onChange={onChange}
                color='black'
                borderColor={isInvalid && 'red'}
            >
                <option value="" disabled>
                    Select {label}...
                </option>
                {options.map((option) => (
                    <option key={option.value} value={option.value}>
                        {option.label}
                    </option>
                ))}
            </Select>
            {isInvalid && errorMessage && (
                <FormErrorMessage>{errorMessage}</FormErrorMessage>
            )}
        </FormControl>
    );
};

export default Dropdown;
